<template>
  <router-view />
</template>

<script>
export default {
  name: "Pickup"
};
</script>
